import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../components/Icon/Icon';
import { AriaRoles } from '../../../constants/AccessibilityConstants';
import { SourceCardConstants as SCC } from '../../../constants/SourceCard';
import { createBEM } from '../../../lib/utils/css';
import IconInteractive from '../IconInteractive/IconInteractive';

import './SourceCardMenuItem.scss';

class SourceCardMenuItem extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    glyph: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    sourceCardAction: PropTypes.object,
    text: PropTypes.object,
    name: PropTypes.string,
    children: PropTypes.node,
    hideSourceCardMenuHelper: PropTypes.func,
    onClickItem: PropTypes.func,
    isDisabled: PropTypes.bool,
    qaTag: PropTypes.string,
  };

  state = {
    isItemHovered: false,
    isActive: false,
  };

  modifyOnClick = e => {
    const { name, hideSourceCardMenuHelper, onClickItem, isDisabled } = this.props;

    e.stopPropagation();

    if (name === SCC.ADDTOPLAYLIST) {
      this.setState({ isActive: !this.state.isActive });
    } else {
      hideSourceCardMenuHelper();
    }
    if (onClickItem) {
      onClickItem(e, { optionName: name, isDisabled: !!isDisabled });
    }
  };

  render() {
    const { className, glyph, sourceCardAction, isDisabled, qaTag } = this.props;
    const { isActive } = this.state;
    const title = sourceCardAction.defaultMessage;
    const text = <FormattedMessage {...sourceCardAction} />;
    const classes = createBEM('SourceCard__menu__item', {
      disabled: isDisabled,
      focus: isActive,
    });

    return (
      <button
        type='button'
        title={title}
        className={classes}
        aria-disabled={isDisabled}
        aria-expanded={isActive}
        role={AriaRoles.MENUITEM}
        tabIndex={isDisabled ? -1 : 0}
        onClick={this.modifyOnClick}
        onMouseEnter={() => this.setState({ isItemHovered: true })}
        onMouseLeave={() => this.setState({ isItemHovered: false })}
        data-qa={qaTag}
      >
        {glyph.hover ? (
          <IconInteractive glyph={glyph} isHovered={this.state.isItemHovered} isMenuItem={true} />
        ) : (
          <Icon className={`${className}__icon`} glyph={glyph} />
        )}
        <div className={`${className}__div`}>{text}</div>
        {this.props.children}
      </button>
    );
  }
}

export default SourceCardMenuItem;
